// extracted by mini-css-extract-plugin
export default {"icon":"Error_icon__Z2-Z7"};